import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo-badge.png";

/* Inline SVG icons (no extra packages needed) */
const icons = {
  pin: (<><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></>),
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />,
  mail: (<><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></>),
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
};

function Icon({ name }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {icons[name]}
    </svg>
  );
}

const css = `
.gfs-foot{background:var(--navy-deep);color:var(--silver);font-size:15.5px}
.gfs-foot-grid{display:grid;grid-template-columns:1.5fr 1fr 1.3fr;gap:48px;padding:64px 0 48px}
.gfs-foot h4{color:#fff;font-size:17px;margin-bottom:18px}
.gfs-foot-brand{display:flex;align-items:center;gap:14px;margin-bottom:18px}
.gfs-foot-brand img{width:64px;height:64px}
.gfs-foot-brand strong{font-family:var(--font-head);color:#fff;font-size:19px;line-height:1.2}
.gfs-foot p{margin-bottom:12px}
.gfs-foot ul{list-style:none;margin:0;padding:0}
.gfs-foot li{margin-bottom:10px}
.gfs-foot a{color:var(--silver);text-decoration:none}
.gfs-foot a:hover{color:var(--gold)}
.gfs-contact{display:grid;gap:16px}
.gfs-contact-row{display:flex;gap:14px;align-items:flex-start}
.gfs-contact-ico{flex:0 0 auto;width:40px;height:40px;border-radius:50%;background:rgba(201,162,75,.14);border:1px solid rgba(201,162,75,.35);color:var(--gold);display:grid;place-items:center}
.gfs-contact-row small{display:block;font-size:13px;color:#8FA1B4;line-height:1.3;margin-bottom:1px}
.gfs-contact-row span,.gfs-contact-row a{color:#E4EAF0;font-size:15.5px;line-height:1.45;word-break:break-word}
.gfs-foot-bar{border-top:1px solid rgba(185,194,204,.2);padding:22px 0;font-size:14px}
.gfs-foot-bar .container{display:flex;justify-content:space-between;gap:16px;flex-wrap:wrap}
.gfs-foot-legal{display:flex;gap:20px}
@media (max-width:900px){.gfs-foot-grid{grid-template-columns:1fr;gap:36px;padding:48px 0 32px}}
`;

export default function Footer() {
  return (
    <>
      <style>{css}</style>
      <footer className="gfs-foot">
        <div className="container gfs-foot-grid">
          <div>
            <div className="gfs-foot-brand">
              <img src={logo} alt="GFS logo" />
              <strong>Guardian Facility<br />Services Ltd</strong>
            </div>
            <p>Property letting, maintenance and cleaning for homes and businesses across the UK.</p>
          </div>
          <div>
            <h4>Quick links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h4>Get in touch</h4>
            <div className="gfs-contact">
              <div className="gfs-contact-row">
                <div className="gfs-contact-ico"><Icon name="pin" /></div>
                <div><small>Office</small><span>78 Compton Avenue, E6 3DP</span></div>
              </div>
              <div className="gfs-contact-row">
                <div className="gfs-contact-ico"><Icon name="phone" /></div>
                <div><small>Phone</small><a href="tel:07459262621">07459 262621</a></div>
              </div>
              <div className="gfs-contact-row">
                <div className="gfs-contact-ico"><Icon name="mail" /></div>
                <div>
                  <small>Email</small>
                  <a href="https://mail.google.com/mail/?view=cm&fs=1&to=guardianfacilityservicesltd@gmail.com" target="_blank" rel="noopener noreferrer">guardianfacilityservicesltd@gmail.com</a>
                </div>
              </div>
              <div className="gfs-contact-row">
                <div className="gfs-contact-ico"><Icon name="clock" /></div>
                <div>
                  <small>Opening hours</small>
                  <span>Mon-Fri: 7:30am - 8:00pm<br />Sat: 9:00am - 5:00pm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="gfs-foot-bar">
          <div className="container">
            <span>
              &copy; 2026 Guardian Facility Services Ltd. All rights reserved. Registered in England and Wales. Company No: 17521897.
            </span>
            <span className="gfs-foot-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}